import { Component, OnInit, AfterViewInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbModel , BreadCrumbService} from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { AdobeAnalyticsService, UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { Router, ActivatedRoute } from '@angular/router';
import { throwError, Observable } from 'rxjs';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { GvpVideoComponent } from 'lib/ng2-sapmp/src/ui-components/gvp-video';
import { BREADCRUMBS,ANALYTICS_CONSTANTS } from 'config';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ChipsService } from '../../ui-components/chips/chips.service';


@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit, AfterViewInit {
  header: string;
  initModal: boolean;
  showOverviewModal: boolean;
  modalClass:  string;
  confirmModalPopup: ConfirmModalPopupModel;
  overviewModalPopup: ConfirmModalPopupModel;
  videoId: any;
  eventEmit: any;
  constructor(private breadCrumbService: BreadCrumbService, private utilities: UtilityService, private chips: ChipsService,
  private router: Router, private adobeAnalyticsService: AdobeAnalyticsService, private httpClientService: HttpClientService) {

    this.initModal = false;
    this.showOverviewModal = false;
    this.initOverviewModal();

   }

  ngOnInit() {
    document.title = this.utilities.getPageTitleConfig()[this.router.routerState.snapshot.url];
    sessionStorage.setItem('callingPageName', 'support');
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    //this.breadCrumbService.setCurrentBreadCrumb({ label: 'Support', routerLink: '/support' });
    this.chips.setChips([ {
      "label": "Home",
      "routerLink": "/home"
    },
    {
      "label": "Support",
      "routerLink": "/support"
    }]);
    this.createPageLoadProperties();
    const pageName = 'supportPage';
    this.requestSupportContent(this.utilities.getEnvConfig().getSupportDocument, pageName).
    subscribe(resp => {
      this.videoId = resp.supportArticles.availableArticle[0].url;
    });
  }

  createPageLoadProperties() {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_SUPPORT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SUPPORT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = ANALYTICS_CONSTANTS.BC_LANGUAGE_EN;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Support';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  ngAfterViewInit() {

  }
get_headers() {
  let headers = new HttpHeaders();
  headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
  return headers;
}
  closeModal(event) {
    this.initModal = false;
  }

  handleError = (error) => {
    return throwError(error);
  }

  initOverviewModal() {
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.overviewModalPopup.modalMessage = '';
    this.overviewModalPopup.modalSubHeader = 'Overview Tutorial';
    this.overviewModalPopup.modalHeader = 'Modal Header';
    this.overviewModalPopup.confirmButtonMessage = 'OK';
    this.overviewModalPopup.showCancelButton = false;
    this.modalClass = 'modal-lg';
  }
  requestSupportContent(id, pageName) {
    return this.httpClientService.get(id + pageName, this.get_headers())
  .pipe(
       map((res: HttpResponse<any>) => res.body)
  ,catchError( this.handleError ));
}
  openOverviewModal() {
    this.showOverviewModal = true;
    this.eventEmit = document.activeElement;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }
}
